import { useVideoPlayer2Setup } from "./hooks/useVideoPlayer2Setup";

export function VideoPlayer2Setup() {
  useVideoPlayer2Setup();
  return null;
}
